
import {
  CLEAR_ERRORS,
  CREATE_COMPANY,
  CREATE_COMPANY_FAIL,
  CREATE_COMPANY_SUCCESS,
  DELETE_COMPANY,
  DELETE_COMPANY_FAIL,
  DELETE_COMPANY_SUCCESS,
  GET_COMPANIES,
  GET_COMPANIES_ALL,
  GET_COMPANIES_ALL_FAIL,
  GET_COMPANIES_ALL_SUCCESS,
  GET_COMPANIES_FAIL,
  GET_COMPANIES_SUCCESS,
  GET_COMPANY,
  GET_COMPANY_FAIL,
  GET_COMPANY_SUCCESS,
  UPDATE_COMPANY,
  UPDATE_COMPANY_FAIL,
  UPDATE_COMPANY_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  companiesData: [],
  allCompaniesData: [],
  pagination: { page: 1, limit: 10, totalPages: 1, total: 0 },
  loading: false,
  createCompanyLoading: false,
  updateCompanyLoading: false,
  deleteCompanyLoading: false,
  getCompanyLoading: false,
  selectedCompany: null,
  message: null,
  confirmDeleted: false,
}

const Company = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COMPANIES:
      return {
        ...state,
        loading: true,
        message: null
      }
    case GET_COMPANIES_SUCCESS:
      return {
        ...state,
        companiesData: action.payload.items,
        pagination: action.payload.pagination,
        loading: false,
      }
    case GET_COMPANIES_FAIL:
      return {
        ...state,
        loading: false,
        message: action.payload
      }

    case GET_COMPANIES_ALL:
      return {
        ...state,
        loading: true,
        message: null
      }
    case GET_COMPANIES_ALL_SUCCESS:
      return {
        ...state,
        allCompaniesData: action.payload.items,
        loading: false,
      }
    case GET_COMPANIES_ALL_FAIL:
      return {
        ...state,
        loading: false,
        message: action.payload
      }

    case CREATE_COMPANY:
      return {
        ...state,
        createCompanyLoading: true
      }
    case CREATE_COMPANY_SUCCESS:
      return {
        ...state,
        createCompanyLoading: false
      }
    case CREATE_COMPANY_FAIL:
      return {
        ...state,
        createCompanyLoading: false,
        message: action.payload
      }
    case GET_COMPANY:
      return {
        ...state,
        getCompanyLoading: true
      }
    case GET_COMPANY_SUCCESS:
      return {
        ...state,
        getCompanyLoading: false,
        selectedCompany: action.payload
      }
    case GET_COMPANY_FAIL:
      return {
        ...state,
        getCompanyLoading: false,
        message: action.payload
      }
    case UPDATE_COMPANY:
      return {
        ...state,
        updateCompanyLoading: true
      }
    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        updateCompanyLoading: false
      }
    case UPDATE_COMPANY_FAIL:
      return {
        ...state,
        updateCompanyLoading: false,
        message: action.payload
      }
    case DELETE_COMPANY:
      return {
        ...state,
        deleteCompanyLoading: true
      }
    case DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        deleteCompanyLoading: false,
        confirmDeleted: true
      }
    case DELETE_COMPANY_FAIL:
      return {
        ...state,
        deleteCompanyLoading: false,
        message: action.payload
      }
    case CLEAR_ERRORS:
      return {
        ...state,
        message: null,
        loading: false,
      }

    default:
      return state
  }
}

export default Company

